<!--  -->
<template>
  <div class="sdjawr">
    <div style="text-align:right;margin-bottom:10px">
      <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="app_id"
        label="公众号app_id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="custom_send_text"
        label="客服接口状态"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.custom_send == 1" class="el-icon-success defaultr" />
          <i v-if="scope.row.custom_send == 2" class="el-icon-warning defaultrse" />
          <i v-if="scope.row.custom_send == 3" class="el-icon-error stopew" />
          {{ scope.row.custom_send_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="template_send_arr"
        label="模板消息被封情况"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="详情"
            width="500"
            trigger="click"
          >
            <el-table :data="scope.row.template_send_arr">
              <el-table-column width="370" align="center" property="template_id" label="template_id" />
              <el-table-column width="100" align="center" property="status_text" label="状态" />
            </el-table>
            <el-button slot="reference" type="success" size="mini">详情</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="template_send_arr"
        label="测试的openid"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div v-for="items,index in scope.row.test_open_ids" :key="index">
            {{ items }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="last_execution_time_text"
        label="最后执行时间"
        align="center"
        width="180"
      />
      <el-table-column
        prop="template_send_arr"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="add(2,scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />

    <el-dialog
      title="公众号"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="30%"
    >
      <addriskdialog ref="addriskview" @updata="updata" />
    </el-dialog>
  </div>

</template>

<script>
import { oatesting } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addriskdialog from './components//addriskdialog.vue'
export default {
  components: { PaginationRight, addriskdialog },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        app_id: null
      },
      dialogVisible: false,
      tableData: [],
      total: null
    }
  },
  created() {
    this.aserlist()
  },
  mounted() {

  },
  methods: {
    async aserlist() {
      const data = await oatesting(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    fetchPageSizeone(e) {
      this.query.pageSize = e
      this.aserlist()
    },
    fetchCurrentPageone(e) {
      this.query.page = e
      this.aserlist()
    },
    add(type, item) {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addriskview.send(type, item)
      }, 100)
    },
    updata() {
      this.dialogVisible = false
      this.aserlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sdjawr{
  padding: 20px;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
